<div style="min-height: 60vh">
<div class="date-filter-container mb-0">
    <div class="date-filter-header">
        <button class="btn date-nav-btn" (click)="decrementDate()" rippleEffect>
            <i data-feather="chevron-left"></i>
        </button>
        <button class="btn date-nav-btn" (click)="incrementDate()" rippleEffect>
            <i data-feather="chevron-right"></i>
        </button>
        <p class="date-display">{{ selectedPeriod || 'Aujourd’hui' }}</p>
    </div>
    <div class="date-filter-buttons">
        <div class="btn-group" role="group">
            <button type="button" class="btn bouttons" rippleEffect (click)="setViewMode('jours')"
                    [class.active]="viewMode === 'jours'">
                <p>Jours</p>
            </button>
            <button type="button" class="btn bouttons" rippleEffect (click)="setViewMode('mois')"
                    [class.active]="viewMode === 'mois'">
                <p>Mois</p>
            </button>
            <button type="button" class="btn bouttons" rippleEffect (click)="setViewMode('annees')"
                    [class.active]="viewMode === 'annees'">
                <p>Année</p>
            </button>
            <button class="btn bouttons" rippleEffect (click)="openFlatpickr()"
                    style="color: rgba(19, 74, 211, 1);">
                <i data-feather="calendar"></i>
            </button>
        </div>
        <input type="text" #datePicker class="flatpickr-input d-none" placeholder="Sélectionner une plage de dates" />
    </div>
</div>

<div class="data-list mb-0 p-0" *ngIf="viewMode === 'jours'">
    <div class="data-list-wrapper">
        <div *ngFor="let day of weekDays" (click)="selectDay(day)"
             [class.selected]="day.dateString === selectedDay" [class.today]="day.isToday" class="day-item">
            {{ day.label }}
        </div>
    </div>
</div>

<div class="data-list mb-0 p-0" *ngIf="viewMode === 'mois'">
    <div class="data-list-wrapper">
        <div *ngFor="let month of months; let i = index" (click)="selectMonth(i)"
             [class.selected]="i === selectedMonthIndex" [class.today]="i === currentMonthIndex" class="month-item">
            {{ month }}
        </div>
    </div>
</div>

<div class="data-list mb-0 p-0" *ngIf="viewMode === 'annees'">
    <div class="data-list-wrapper">
        <div *ngFor="let year of years" (click)="selectYear(year)"
             [class.selected]="year === selectedYear" [class.today]="year === currentYear" class="year-item">
            {{ year }}
        </div>
    </div>
</div>

<div class="d-flex" style="position: relative;">
    <div class="card-body row m-0" style="padding: 24px">
        <div class="input-group form-password-toggle d-flex" style="width: 300px;">
            <input
                    type="text"
                    class="form-control"
                    placeholder="Recherche par mot clé"
                    aria-label="Recherche par mot clé"
                    aria-describedby="basic-addon-search1"
                    [(ngModel)]="searchTerm"
                    (ngModelChange)="onSearch()"
            />
            <div class="input-group-append">
                <span
                        class="input-group-text"
                        id="basic-addon-search1"
                        style="color: black; cursor: pointer; background-color: transparent; border-left: none; padding: 0 10px;"
                >
                    <i data-feather="search" [size]="20"></i>
                </span>
            </div>
        </div>
        <button
                type="button"
                class="btn btn-outline-primary btn-icon"
                (click)="toggleFilter()"
                style="margin-left: 10px;"
        >
            <span data-feather="filter"></span>
        </button>

    </div>

    <!-- Panneau de filtres pour Vente -->
    <div
        #filterPanelVente
        class="card filter-sidebar"
        *ngIf="showFilter && baseRoute === '/vente'"
        style="width: 320px; max-height: 445px;"
    >
        <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="card-title mb-0">Filtres</h4>
            <button class="btn btn-sm btn-icon btn-light" (click)="toggleFilter()" aria-label="Fermer">
                <i class="bx bx-x"></i>
            </button>
        </div>
        <div class="card-body d-flex flex-column p-1">
            <div class="flex-grow-1 overflow-auto pe-1">
                <div class="mb-1">
                    <label class="form-label">Type</label>
                    <select class="form-select form-control" [(ngModel)]="filters.type">
                        <option value="">Tous (optionnel)</option>
                        <option value="Professionnel">Professionnel</option>
                        <option value="Particulier">Particulier</option>
                    </select>
                </div>
                <div class="mb-1">
                    <label class="form-label">Raison sociale</label>
                    <input
                            type="text"
                            class="form-control"
                            [(ngModel)]="filters.raison"
                            placeholder="Entrez la raison sociale (optionnel)"
                    />
                </div>
                <div class="mb-1">
                    <label class="form-label">Matricule fiscal</label>
                    <input
                            type="text"
                            class="form-control"
                            [(ngModel)]="filters.matricule"
                            placeholder="Entrez le matricule fiscal (optionnel)"
                    />
                </div>
                <div class="mb-1">
                    <label class="form-label">Chiffre d’affaires</label>
                    <div class="d-flex w-100 gap-2">
                        <select class="form-select form-control flex-grow-1" [(ngModel)]="filters.operator">
                            <option value="=">=</option>
                            <option value=">">></option>
                            <option value="<"><</option>
                        </select>
                        <input
                                type="number"
                                class="form-control flex-grow-1"
                                [(ngModel)]="filters.chiffre_aff"
                                placeholder="Montant (optionnel)"
                        />
                    </div>
                </div>
                <div class="mb-1">
                    <label class="form-label">Client endetté</label>
                    <select class="form-select form-control" [(ngModel)]="filters.indebted">
                        <option value="">Tous (optionnel)</option>
                        <option value="true">Oui</option>
                        <option value="false">Non</option>
                    </select>
                </div>
            </div>
            <div class="pt-2 d-flex justify-content-end gap-1">
                <button class="btn btn-outline-secondary" (click)="resetFilters()">Réinitialiser</button>
                <button class="btn btn-primary" (click)="applyFilters()">Appliquer</button>
            </div>
        </div>
    </div>

    <div
        #filterPanelAchat
        class="card filter-sidebar"
        *ngIf="showFilter && baseRoute === '/achat'"
        style="width: 320px; max-height: 445px;"
    >
        <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="card-title mb-0">Filtres</h4>
            <button class="btn btn-sm btn-icon btn-light" (click)="toggleFilter()" aria-label="Fermer">
                <i class="bx bx-x"></i>
            </button>
        </div>
        <div class="card-body d-flex flex-column p-1">
            <div class="flex-grow-1 overflow-auto pe-1">
                <div class="mb-1">
                    <label class="form-label">Fournisseur</label>
                    <input
                            type="text"
                            class="form-control"
                            [(ngModel)]="filters.fournisseur"
                            placeholder="Entrez le nom du fournisseur (optionnel)"
                    />
                </div>
                <div class="mb-1">
                    <label class="form-label">Projet</label>
                    <input
                            type="text"
                            class="form-control"
                            [(ngModel)]="filters.projet"
                            placeholder="Entrez le nom du projet (optionnel)"
                    />
                </div>
                <div class="mb-1">
                    <label class="form-label">Montant</label>
                    <div class="d-flex w-100 gap-2">
                        <select class="form-select form-control flex-grow-1" [(ngModel)]="filters.operator">
                            <option value="=">=</option>
                            <option value=">">></option>
                            <option value="<"><</option>
                        </select>
                        <input
                                type="number"
                                class="form-control flex-grow-1"
                                [(ngModel)]="filters.montant"
                                placeholder="Montant (optionnel)"
                        />
                    </div>
                </div>
                <div class="mb-1">
                    <label class="form-label">État</label>
                    <select class="form-select form-control" [(ngModel)]="filters.status">
                        <option value="">Tous (optionnel)</option>
                        <option *ngFor="let status of statuses" [value]="status">{{ status }}</option>
                    </select>
                </div>
                <div class="mb-1">
                    <label class="form-label">Date de création</label>
                    <div class="d-flex w-100 gap-2">
                        <input
                                type="text"
                                class="form-control flatpickr-input"
                                placeholder="Du (optionnel)"
                                [(ngModel)]="filters.dateFrom"
                                (ngModelChange)="applyFilters()"
                                #dateFromPicker
                        />
                        <input
                                type="text"
                                class="form-control flatpickr-input"
                                placeholder="Jusqu’à (optionnel)"
                                [(ngModel)]="filters.dateTo"
                                (ngModelChange)="applyFilters()"
                                #dateToPicker
                        />
                    </div>
                </div>
            </div>
            <div class="pt-2 d-flex justify-content-end gap-1">
                <button class="btn btn-outline-secondary" (click)="resetFilters()">Réinitialiser</button>
                <button class="btn btn-primary" (click)="applyFilters()">Appliquer</button>
            </div>
        </div>
    </div>
</div>

<!-- Table -->
<div class="table-full-width">
    <div *ngIf="isLoadingDocuments" class="text-center p-4">
        <div class="spinner-border" role="status"><span class="sr-only">Chargement...</span></div>
    </div>
    <div class="table-responsive" *ngIf="!isLoadingDocuments" style="height: 540px">
        <table class="table table-hover">
            <thead class="custom-header">
            <tr>
                <th style="width: 15%">RÉFÉRENCE</th>
                <th style="width: 13%">DATE</th>
                <th style="width: 15%" class="uppercase">Méthode de paiement</th>
                <th style="width: 15%" class="uppercase">Document</th>
                <th style="width: 16%" class="uppercase">Montant total</th>
                <th style="width: 16%" class="uppercase">Montant restant</th>
                <th style="width: 200px">ACTION</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let doc of paginatedDocuments">
                <td>{{ doc.reference }}</td>
                <td>{{ doc.date }}</td>
                <td>{{ doc.methodPaiement }}</td>
                <td>{{ doc.documentType }}</td>
                <td>{{ doc.montantTotal }}</td>
                <td>{{ doc.montantRestant }}</td>
                <td>
                    <button type="button" class="btn btn-sm btn-primary" (click)="openPaiementModalForDocument(doc)">
                        Paiement
                    </button>
                </td>
            </tr>
            <tr *ngIf="documents.length === 0 && !isLoadingDocuments">
                <td colspan="7" class="text-center p-4">Aucun document avec ce statut</td>
            </tr>
            </tbody>
        </table>
    </div>

    <!-- Pagination (même design que shared) -->
    <div class="row d-flex pagination-row" *ngIf="!isLoadingDocuments && documents.length > 0">
        <div class="col-md-6 col-12">
            <div class="d-flex justify-content-between align-items-center">
                <label class="d-flex align-items-center" style="font-size: 15px; margin-left: 24px">
                    Afficher
                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption"
                            (ngModelChange)="updatePagination()">
                        <option [value]="10">10</option>
                        <option [value]="25">25</option>
                        <option [value]="50">50</option>
                        <option [value]="100">100</option>
                    </select>
                </label>
            </div>
        </div>
        <div class="col-md-6 col-12 text-end">
            <div class="d-flex flex-wrap justify-content-end gap-2 pagination-buttons" style="margin-right: 24px">
                <div class="page-box" [class.disabled]="currentPage === 1" (click)="currentPage > 1 && changePage(1)">«</div>
                <div class="page-box" [class.disabled]="currentPage === 1"
                     (click)="currentPage > 1 && changePage(currentPage - 1)">‹</div>
                <div *ngFor="let page of pages" class="page-box" [class.active]="page === currentPage"
                     (click)="changePage(page)">{{ page }}</div>
                <div class="page-box" [class.disabled]="currentPage === totalPages"
                     (click)="currentPage < totalPages && changePage(currentPage + 1)">›</div>
                <div class="page-box" [class.disabled]="currentPage === totalPages"
                     (click)="currentPage < totalPages && changePage(totalPages)">»</div>
            </div>
        </div>
    </div>
</div>
</div>
